import { cn } from "@/lib/utils";

/** Small online/offline indicator dot. */
export function PresenceDot({ online, className }: { online: boolean; className?: string }) {
  return (
    <span
      aria-label={online ? "Online" : "Offline"}
      className={cn(
        "border-card size-2.5 rounded-full border-2",
        online ? "bg-success" : "bg-muted-foreground/40",
        className,
      )}
    />
  );
}
